/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rmf_Banner_ConnectingInputs */

const en_rmf_banner_connecting = /** @type {(inputs: Rmf_Banner_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`connecting socket`)
};

const fr_rmf_banner_connecting = /** @type {(inputs: Rmf_Banner_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`connexion au socket`)
};

const ms_sg2_rmf_banner_connecting = /** @type {(inputs: Rmf_Banner_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`menyambung soket`)
};

/**
* | output |
* | --- |
* | "connecting socket" |
*
* @param {Rmf_Banner_ConnectingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_banner_connecting = /** @type {((inputs?: Rmf_Banner_ConnectingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Banner_ConnectingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_banner_connecting(inputs)
	if (locale === "fr") return fr_rmf_banner_connecting(inputs)
	return ms_sg2_rmf_banner_connecting(inputs)
});